import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/stfil-logo.svg';
const _hoisted_1 = {
  class: "preloader preloader-bg-white d-flex align-items-center justify-content-center",
  style: {
    "width": "100%",
    "height": "40vh",
    "background-color": "white"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "block"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "loader-image mb-20"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}